import { useEffect, useState } from "react";
import styles from "./administrationManagment.module.css";
import { getFAQs } from "services/FAQ/get-FAQs";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaPlusCircle } from "react-icons/fa";
import { updateFAQ } from "services/FAQ/update-FAQs";
import { deleteFAQs } from "services/FAQ/delete-FAQs";
import Popup from "components/Popup/popup";
import { setFAQs } from "services/FAQ/set-FAQs";
import SuccessPopup from "components/successPopup/successPopup";

export default function FAQManagment() {
    const [faqData, setFaqData] = useState<{ id: string; question: string; answer: string; is_active: boolean }[]>([]);
    const [editedFAQs, setEditedFAQs] = useState<{ [key: string]: { question: string; answer: string; is_active: boolean } }>({});
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [newFAQ, setNewFAQ] = useState({ question: "", answer: "", is_active: false });
    const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);

    const fetchData = async () => {
        try {
            const faqs = await getFAQs();
            const formattedFaqs = faqs.map((faq: { is_active: string; }) => ({
                ...faq,
                is_active: Boolean(faq.is_active)
            }));
            setFaqData(formattedFaqs);
        } catch (error) {
            console.error("Fehler beim Abrufen der daten:", error);
        }
    };
    const [visibleIndex, setVisibleIndex] = useState<number | null>(null);

    const toggleFormVisibility = (index: number) => {
        setVisibleIndex(visibleIndex === index ? null : index);
    };

    const handleCheckboxChange = (id: string) => {
        setEditedFAQs((prevState) => ({
            ...prevState,
            [id]: {
                ...prevState[id],
                is_active: !prevState[id]?.is_active,
            },
        }));
    };

    const handleUpdate = async (faq: { id: string; question: string; answer: string; is_active: boolean }) => {
        try {
            const updatedFAQ = {
                question: editedFAQs[faq.id]?.question || faq.question,
                answer: editedFAQs[faq.id]?.answer || faq.answer,
                is_active: editedFAQs[faq.id]?.is_active !== undefined ? editedFAQs[faq.id]?.is_active : faq.is_active,
            };
            await updateFAQ(faq.id, updatedFAQ);
            setIsSuccessPopupOpen(true)
            fetchData();
        } catch (error) {
            console.error("Fehler beim Aktualisieren der FAQ:", error);
        }
    };

    const handleAdd = async () => {
        try {
            await setFAQs(newFAQ);
            fetchData();
            setIsSuccessPopupOpen(true);
        } catch (error) {
            console.error("Fehler beim Hinzufügen einer FAQ:", error);
        }
    };

    const handlePopupClose = () => {
        setIsPopupOpen(false);
        setNewFAQ({ question: "", answer: "", is_active: false })
    };

    const handleDelete = async (id: string) => {
        try {
            await deleteFAQs(id);
            setIsSuccessPopupOpen(true)
            fetchData();
        } catch (error) {
            console.error("Fehler beim Löschen einer FAQ:", error);
        }

    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className={styles.EditForm}>
            {faqData.map((faq, index) => (
                <div key={faq.id} >
                    <div className={styles.itemHeade} onClick={() => toggleFormVisibility(index)}>
                        <p>Frage {index + 1}</p>
                        {visibleIndex === index ? <IoIosArrowUp /> : <IoIosArrowDown />}
                    </div>
                    {visibleIndex === index && (
                        <div className={styles.FormContainer}>
                            <div className={styles.cancelOptionsContainer}>
                                <div className={styles.isActiveOptionsRow} key={`${faq.id}`}>
                                    <div className={styles.isActiveOptionsRowLabels}>
                                        <label>ist Aktiv</label>
                                    </div>
                                    <input
                                        checked={editedFAQs[faq.id]?.is_active !== undefined ? editedFAQs[faq.id]?.is_active : faq.is_active}
                                        id={`isActive-${faq.id}`}
                                        type="checkbox"
                                        onChange={() => handleCheckboxChange(faq.id)}
                                    />
                                </div>
                            </div>

                            <div className={commonStyles.formGroup}>
                                <label htmlFor="question">Frage*</label>
                                <input
                                    type="text"
                                    id="question"
                                    name="question"
                                    value={editedFAQs[faq.id]?.question || faq.question}
                                    required
                                    onChange={(e) => {
                                        setEditedFAQs({
                                            ...editedFAQs,
                                            [faq.id]: {
                                                ...editedFAQs[faq.id],
                                                question: e.target.value,
                                            },
                                        });
                                    }}
                                />
                            </div>
                            <div className={commonStyles.formGroup}>
                                <label htmlFor="answer">Antwort*</label>
                                <textarea
                                    id="answer"
                                    name="answer"
                                    value={editedFAQs[faq.id]?.answer || faq.answer}
                                    required
                                    rows={5}
                                    onChange={(e) => {
                                        setEditedFAQs({
                                            ...editedFAQs,
                                            [faq.id]: {
                                                ...editedFAQs[faq.id],
                                                answer: e.target.value,
                                            },
                                        });
                                    }}
                                />
                            </div>
                            <div className={styles.actionButtons}>
                                <button
                                    className={`${commonStyles.commonButton} ${commonStyles.backButton}`}
                                    onClick={() => handleDelete(faq.id)}
                                >
                                    Löschen
                                </button>
                                <button
                                    className={`${commonStyles.commonButton} ${commonStyles.submitButton}`}
                                    onClick={() => handleUpdate(faq)}
                                >
                                    Speichern
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            ))}
            <section className={styles.section}>
                <div className={styles.addButtonContainer}>
                    <button
                        type="button"
                        className={`${commonStyles.commonButton} ${styles.addfaqButton}`}
                        onClick={() => { setIsPopupOpen(true); }}
                    >
                        <span>FAQ hinzufügen</span>
                        <FaPlusCircle className={`${commonStyles.commonButtonIcon} ${styles.buttonIcon}`} />
                    </button>
                </div>
            </section>

            <Popup
                title={"FAQ hinzufügen"}
                submitLabel={"Hinzufügen"}
                closeLabel={"Abbrechen"}
                isWithButton={true}
                isOpen={isPopupOpen}
                onClose={handlePopupClose}
                onSubmit={handleAdd}
            >
                <div className={styles.cancelOptionsContainer}>
                    <div className={styles.isActiveOptionsRow}>
                        <div className={styles.isActiveOptionsRowLabels}>
                            <label>ist Aktiv</label>
                        </div>
                        <input
                            checked={newFAQ.is_active}
                            id="isActive"
                            type="checkbox"
                            onChange={() => setNewFAQ({ ...newFAQ, is_active: !newFAQ.is_active })}
                        />
                    </div>
                </div>

                <div className={commonStyles.formGroup}>
                    <label htmlFor="question">Frage*</label>
                    <input
                        type="text"
                        id="question"
                        name="question"
                        value={newFAQ.question}
                        required
                        onChange={(e) => setNewFAQ({ ...newFAQ, question: e.target.value })}
                    />
                </div>
                <div className={commonStyles.formGroup}>
                    <label htmlFor="answer">Antwort*</label>
                    <textarea
                        id="answer"
                        name="answer"
                        value={newFAQ.answer}
                        required
                        rows={5}
                        onChange={(e) => setNewFAQ({ ...newFAQ, answer: e.target.value })}
                    />
                </div>
            </Popup>


            <SuccessPopup isPopupOpen={isSuccessPopupOpen} onClose={() => {
                handlePopupClose();
                setIsSuccessPopupOpen(false);
            }} />
        </div>
    );
}
